export enum ProductCategory {
  Ski = 1,
  Boots = 2,
  Snowboard = 3,
  Fun = 4,
  Nordic = 5,
  Helmet = 6
}
